
<template>
    <div class="search-wrap searchb2c">
        <article class="search-main clearfix">
            <div class="pull-right">
                <Form inline>
                    <Button type="primary" @click="update(true)" icon="ios-search">查询</Button>
                    <Button @click="resetdata" icon='md-refresh'>重置</Button>
                    <Button type="dashed" @click="isOpen=!isOpen">更多查询<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                </Form>
            </div>
            <div class="pull-right">
                <Form :label-width="80" inline>
                    <FormItem label='店铺'>
                        <Select v-model="formData.EQ_accountFlag" filterable clearable>
                            <Option v-for="item in accountsAll" :value="item.value" :key="item.value">{{item.label}}</Option>
                        </Select>
                    </FormItem>
                     <FormItem label='SellerSKU'>
                        <Input clearable v-model.trim="formData.CN_sellerSku" />
                    </FormItem>
                     <FormItem label='ERPSKU'>
                        <Input clearable v-model.trim="formData.CN_erpSku" />
                    </FormItem>
                </Form>
            </div>

        </article>
        <transition name='slide-both' >
            <div v-show="isOpen">
                <Form class="search-other" :label-width="110" inline >

                    <FormItem label='项目' style="width:330px;">
                        <Select v-model="formData.EQ_lineId" filterable clearable>
                            <Option v-for="item in getNewDifferentAllProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label='Asin' style="width:330px;">
                        <vInput clearable v-model="formData.EQ_asin"></vInput>
                    </FormItem>
                    <FormItem label='是否推送库存' style="width:330px;">
                        <Select v-model="formData.EQ_isPush" filterable clearable>
                            <Option v-for="item in isPushList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </div>
        </transition>
        <transition>
            <Form inline class="search-other" v-if="changekeys!='LE_latestShipDate'">
                <Button class="margin-right-5 dark-primary" @click="handleModal('add')">添加</Button>

                <Button type="success" class="margin-right-5" @click="handleModal('import')">导入</Button>

                <Button type="info" class="margin-right-5" @click="exportXlsx">查询条件导出</Button>

                <Button type="error" class="margin-right-5" @click="handleModal('delete')">批量移除</Button>
            </Form>
        </transition>
    </div>
</template>

<script>
    import { HttpGroupRuleItem } from '@/service/boss/allot'
    import { HttpGetStates } from '@/service/boss/b2corder'
    import { mapState,mapGetters } from 'vuex'

    export default {
        data() {
            return {
                SYSID:'',
                aaaa:"",
                isOpen: false,
                routerName:this.$route.name,
                states:[],
                formData:{
                    IN_lineId:"",
                    EQ_property:"SFP"
                },
                allisAddition:'',
                changekeys:'',
            };
        },
        created() {
            this.update();
            // this.timehandle()
        },
        computed: {
            ...mapState('boss',['accounts']),
                accountsAll() {
                    let arr = [];
                    this.accounts.map(item=>{
                        if(item.type=='amazon'){
                            let data =  {
                                label:item.flag,
                                value:item.flag
                            };
                            arr.push(data)
                        }
                    })
                    return arr
                },
            ...mapGetters('diction',['getNewDifferentAllProductList']),
            isPushList(){
                return [
                    {label:'是',value:'Y'},
                    {label:'否',value:'N'},
                ]
            },
            propsData(){
                return [
                    {label:'店铺',key:'EQ_accountFlag',tag:'vSelect',value:this.accountsAll},
                    {label:'SellerSKU',key:'CN_sellerSku'},
                    {label:'ERPSKU',key:'CN_erpSku'},
                    {label:this.$t('global.common.line',{defaultValue:'项目'}),key:'EQ_lineId',tag:'Select',value:this.getNewDifferentAllProductList},
                    {label:'Asin',key:'EQ_asin'},
                    {label:'是否推送库存',key:'EQ_isPush',tag:'Select',value:this.isPushList},

                ]
            },
    },
    methods: {

        handleModal(type,id) {
            this.$parent.handleOperate(id,type)
        },

        update(type,parms){
            const formdata = { ...this.formData };
            this.$emit('on-update', { property:"SFP",search: formdata, page: 1 });
        },
        resetdata(){
            this.formData = {}
            this.$emit('on-update', { property:"SFP",search: this.formData, page: 1 });
        },
        exportXlsx(){
            // 查询条件导出
            if (sessionStorage.get("downloadTotal") > 2000) {
                this.$Message.error("请导出2000条以内的数据");
            } else {
                this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v1/ProductChannel/exportXlsx", {
                    "search[EQ_accountFlag]": this.formData.EQ_accountFlag ? this.formData.EQ_accountFlag : '',
                    "search[EQ_sellerSku]": this.formData.EQ_sellerSku ? this.formData.EQ_sellerSku : '',
                    "search[EQ_erpSku]": this.formData.EQ_erpSku ? this.formData.EQ_erpSku : '',
                    "search[EQ_property]": this.formData.EQ_property,

                    "search[EQ_lineId]": this.formData.EQ_lineId ? this.formData.EQ_lineId : '',
                    "search[EQ_asin]": this.formData.EQ_asin ? this.formData.EQ_asin : '',
                    "search[EQ_isPush]": this.formData.EQ_isPush ? this.formData.EQ_isPush : '',
                }, {
                    executor: 'request',
                    download: true,
                }).catch(err => {
                    // this.$VMessage.error(err.message);
                })
            }
        },
    },
    };
</script>
